import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-secondary-700">
                <i className="ri-question-line" aria-hidden="true"></i>
                Perguntas frequentes
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                Tire suas dúvidas antes de decidir.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                Reunimos as perguntas mais comuns. Não encontrou o que procurava? Fale com um
                especialista.
              </p>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="flex flex-col gap-3">
              {faqs.map((faq, index) => {
                const isOpen = open === index;
                return (
                  <div
                    key={faq.question}
                    className={`rounded-xl border transition-colors ${
                      isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {faq.question}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i
                          className={isOpen ? "ri-subtract-line" : "ri-add-line"}
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}